import { render, staticRenderFns } from "./CompVideo.vue?vue&type=template&id=63501770&scoped=true&"
import script from "./CompVideo.vue?vue&type=script&lang=ts&"
export * from "./CompVideo.vue?vue&type=script&lang=ts&"
import style0 from "./CompVideo.vue?vue&type=style&index=0&id=63501770&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63501770",
  null
  
)

export default component.exports